import { useMemo } from "react";

let nextId = 1;

export default function useGeneratedId(providedId?: string) {
  return useMemo(() => providedId ?? `generated-id-${++nextId}`, [providedId]);
}
